/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

// Style Sheet File
import "./footerStyles.css";

// Imported Images and Icons
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";
import FeedbackRecorder from "../FeedbackRecorder";
import useHideOnScroll from "../../hooks/useHideOnScroll";

function Footer() {
  const date = new Date();
  const year = date.getFullYear();
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const theme = useTheme();
  const linkColor = theme.palette.primary.main;

  // pb-24 below reserves clearance under the mobile BottomNav dock (fixed,
  // floating over content). That dock now auto-hides on scroll down — once
  // it's hidden, the reserved clearance is just dead grey space at the very
  // bottom of the page, so collapse it down to a small resting gap while the
  // dock is off-screen and only restore the full clearance while it's
  // actually visible (top of page, or right after scrolling up).
  const isMobileView = useMediaQuery("(max-width:767px)");
  const navHidden = useHideOnScroll(8, isMobileView);

  return (
    <section
      className="dashboardFooter px-6 pb-24 md:pb-6 container block xl:grid xl:grid-cols-2 xl:items-center"
      style={{
        paddingBottom: isMobileView && navHidden ? "1rem" : undefined,
        transition: "padding-bottom 0.3s ease-in-out",
      }}
    >
      {/* Two short lines instead of one long sentence — the combined
          "All rights reserved. Copyright © ... made with ♥ by ... Version ..."
          line wrapped awkwardly mid-sentence on phone widths. */}
      <div className="footerInfo">
        <p className="copyrightLine text-[#8392AB]">
          &#169; {year} <span className="font-semibold text-[#252F40]">Game My Biz</span>. All rights reserved.
        </p>
        <p className="madeWithLine text-[#98A2B3]">
          Made with <FavoriteRoundedIcon className="text-[#EA0606]" />
          {process.env.REACT_APP_VERSION && <> &nbsp;&middot;&nbsp; v{process.env.REACT_APP_VERSION}</>}
        </p>
      </div>
      <div className="footerLinks xl:justify-self-end" style={{ "--footer-link-color": linkColor }}>
        {/* <a href="">Documentation</a> */}
        <a href="" className="footerLink">Blog</a>
        <a href="" className="footerLink">Help</a>
        <a href="#" className="footerLink" onClick={()=>setFeedbackOpen(true)}>Feedback</a>
      </div>
      {feedbackOpen && <FeedbackRecorder open={feedbackOpen} closeDialog={()=>setFeedbackOpen(false)} />}
    </section>
  );
}

export default Footer;
